"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shape = void 0;
const Scene_1 = require("../Scene");
const SceneChild_1 = require("../SceneChild");
const ShapeBase_1 = require("./ShapeBase");
/**
 * Container of ShapeBase or Group, it applies transformations on each repetition
 *
 * @category Scene.Containers
 */
class Shape extends ShapeBase_1.ShapeBase {
    /**
     * Creates an instance of Shape.
     *
     * @param {ShapeSettings} [settings={}]
     */
    constructor(settings) {
        settings.type = settings.type || 'Shape';
        super(settings);
        if (settings.shape instanceof SceneChild_1.SceneChild) {
            this.shape = settings.shape;
        }
        else {
            console.warn("[Urpflanze:Shape] requires the 'shape' property to be instance of SceneChild,\nYou passed:", settings.shape);
        }
        this.shapeUseParent = !!settings.shapeUseParent;
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
    /**
     * Check if shape is static
     *
     * @returns {boolean}
     */
    isStatic() {
        // return super.isStatic() && !this.shapeUseParent
        return super.isStatic() && (this.shape ? this.shape.isStatic() : true);
    }
    /**
     * Check if shape has static index
     *
     * @returns {boolean}
     */
    isStaticIndexed() {
        return super.isStaticIndexed() && (this.shape ? this.shape.isStaticIndexed() : true);
    }
    /**
     * Find shape by id or name
     *
     * @param {number | string} idOrName
     * @returns {(SceneChild | null)}
     */
    find(idOrName) {
        if (this.id === idOrName || this.name === idOrName)
            return this;
        if (this.shape)
            return this.shape.find(idOrName);
        return null;
    }
    /**
     * Return length of buffer
     *
     * @param {PropArguments} propArguments
     * @returns {number}
     */
    getBufferLength(propArguments) {
        if (this.bStatic && this.buffer && this.buffer.length > 0)
            return this.buffer.length;
        const childBufferLength = this.shape ? this.shape.getBufferLength(propArguments) : 0;
        return childBufferLength * this.getRepetitionCount();
    }
    /**
     * Return a buffer of children shape or loop generated buffer
     *
     * @protected
     * @param {number} generateId
     * @param {PropArguments} propArguments
     * @returns {Float32Array}
     */
    generateBuffer(generateId, propArguments) {
        if (this.shape) {
            if (this.shapeUseParent || !this.shape.isGenerated(generateId)) {
                if (this.shapeUseParent) {
                    this.shape.clearBuffer(true, false);
                }
                this.shape.generate(generateId, false, propArguments);
            }
            return this.shape.getBuffer();
        }
        return Shape.EMPTY_BUFFER;
    }
    /**
     * Return bounding
     *
     * @param {boolean} bDirectSceneChild
     * @returns {IShapeBounding}
     */
    getShapeBounding() {
        if (this.shape) {
            return this.shape.getBounding();
        }
        return this.bounding; // empty bounding defined in ShapeBase
    }
    /**
     * Add to indexed buffer
     *
     * @protected
     * @param {number} frameLength
     * @param {IRepetition} repetition
     * @returns {number} nextIndex
     */
    addIndex(frameLength, repetition, singleRepetitionBounding) {
        if (this.shape) {
            const childIndexedBuffer = this.shape.getIndexedBuffer() || [];
            const parentBufferIndex = {
                shape: this,
                frameLength,
                singleRepetitionBounding,
                repetition: {
                    type: repetition.type,
                    angle: repetition.angle,
                    index: repetition.index,
                    count: repetition.count,
                    offset: repetition.offset,
                    row: {
                        index: repetition.row.index,
                        count: repetition.row.count,
                        offset: repetition.row.offset,
                    },
                    col: {
                        index: repetition.col.index,
                        count: repetition.col.count,
                        offset: repetition.col.offset,
                    },
                },
            };
            for (let i = 0, len = childIndexedBuffer.length; i < len; i++) {
                const currentIndexed = { ...childIndexedBuffer[i] };
                const parent = currentIndexed.parent
                    ? Shape.setIndexedParent(currentIndexed.parent, parentBufferIndex)
                    : parentBufferIndex;
                this.indexedBuffer.push({ ...currentIndexed, parent });
            }
        }
    }
    /**
     * Set parent of indexed
     *
     * @static
     * @param {(IBufferIndex )} current
     * @param {IBufferIndex} parent
     * @returns {(IBufferIndex )}
     */
    static setIndexedParent(current, parent) {
        const index = {
            ...current,
        };
        index.parent = current.parent ? Shape.setIndexedParent(current.parent, parent) : parent;
        return index;
    }
    /**
     * Set shape
     *
     * @param {(SceneChild | undefined)} [shape]
     */
    setShape(shape) {
        if (typeof shape === 'undefined') {
            this.shape = undefined;
            this.clearBuffer(true, true);
        }
        else {
            this.scene && Scene_1.Scene.propagateToChilden(shape, this.scene);
            this.shape = shape;
            this.shape.clearBuffer(true, true);
        }
    }
}
exports.Shape = Shape;
//# sourceMappingURL=Shape.js.map